import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  height: "50",
  width: "46.629",
  viewBox: "0 0 46.629 50",
  ...extra,
  children: [title, /*#__PURE__*/_jsx("path", {
    d: "M36.045 0l-2.674 3.42 10.584 8.275 2.674-3.42L36.045 0zM10.584.014L0 8.289l2.674 3.42 10.584-8.275-2.674-3.42zm12.689 4.203C10.665 4.217.33 14.447.33 27.057c0 5.477 1.962 10.54 5.27 14.572l-4.444 4.443 3.1 3.102L8.7 44.729c3.927 3.307 8.992 5.27 14.572 5.27 5.581 0 10.645-1.963 14.573-5.27l4.547 4.548 3.1-3.101-4.548-4.547a22.89 22.89 0 0 0 5.168-14.47c0-12.711-10.23-22.942-22.84-22.942zm0 4.443c10.232 0 18.498 8.269 18.498 18.5 0 10.232-8.369 18.397-18.498 18.397-10.231 0-18.5-8.269-18.5-18.5 0-10.232 8.269-18.397 18.5-18.397zm-1.447 2.274v17.982h13.332v-3.307H25.029V10.934h-3.203z"
  })]
});